import HttpService from "@core/services/http/http.service";
import { Content, CreateContent, GetListResponse } from "@app/types";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _ContentService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<Content>>(
      "/admin/api/v2/filter-words",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public create(content: CreateContent) {
    return HttpService.post("/admin/api/v2/filter-words", {
      body: { ...content },
    });
  }

  public update(contentId: number, content: CreateContent) {
    return HttpService.patch(`/admin/api/v2/filter-words/${contentId}`, {
      body: { ...content },
    });
  }

  public delete(contentId: number) {
    return HttpService.delete(`/admin/api/v2/filter-words/${contentId}`);
  }
}

const ContentService = new _ContentService();

export default ContentService;
